import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Spinner } from 'react-bootstrap';
import { Bar, Pie } from 'react-chartjs-2';
import { Chart as ChartJS, registerables } from 'chart.js';

ChartJS.register(...registerables);

const Analytics = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Mock data for localhost
    const mockStats = {
      totalBookings: 125,
      totalRevenue: 12500,
      activeVehicles: 8,
      totalUsers: 42,
      statusCounts: {
        pending: 15,
        confirmed: 75,
        completed: 30,
        cancelled: 5
      },
      revenueByDate: {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
        data: [1500, 1800, 2100, 2400, 2000, 2300]
      },
      popularVehicles: {
        labels: ['Luxury Sedan', 'SUV', 'Limousine', 'Party Bus'],
        data: [45, 35, 25, 15]
      }
    };

    setTimeout(() => {
      setStats(mockStats);
      setLoading(false);
    }, 1000);
  }, []);

  const bookingStatusData = {
    labels: ['Pending', 'Confirmed', 'Completed', 'Cancelled'],
    datasets: [
      {
        data: [
          stats?.statusCounts?.pending || 0,
          stats?.statusCounts?.confirmed || 0,
          stats?.statusCounts?.completed || 0,
          stats?.statusCounts?.cancelled || 0,
        ],
        backgroundColor: [
          '#FFCE56',
          '#36A2EB',
          '#4BC0C0',
          '#FF6384',
        ],
      },
    ],
  };

  const revenueData = {
    labels: stats?.revenueByDate?.labels || [],
    datasets: [
      {
        label: 'Revenue',
        data: stats?.revenueByDate?.data || [],
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      },
    ],
  };

  const vehiclePopularityData = {
    labels: stats?.popularVehicles?.labels || [],
    datasets: [
      {
        label: 'Bookings',
        data: stats?.popularVehicles?.data || [],
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1,
      },
    ],
  };

  return (
    <div className="dashboard-container">
      <h2>Analytics Dashboard</h2>
      
      {loading ? (
        <div className="text-center">
          <Spinner animation="border" />
        </div>
      ) : (
        <>
          <Row className="mb-4">
            <Col md={3}>
              <Card>
                <Card.Body>
                  <Card.Title>Total Bookings</Card.Title>
                  <Card.Text className="display-6">
                    {stats?.totalBookings || 0}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3}>
              <Card>
                <Card.Body>
                  <Card.Title>Revenue</Card.Title>
                  <Card.Text className="display-6">
                    ${(stats?.totalRevenue || 0).toFixed(2)}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3}>
              <Card>
                <Card.Body>
                  <Card.Title>Active Vehicles</Card.Title>
                  <Card.Text className="display-6">
                    {stats?.activeVehicles || 0}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3}>
              <Card>
                <Card.Body>
                  <Card.Title>Registered Users</Card.Title>
                  <Card.Text className="display-6">
                    {stats?.totalUsers || 0}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row className="mb-4">
            <Col md={6}>
              <Card>
                <Card.Body>
                  <Card.Title>Booking Status</Card.Title>
                  <div style={{ height: '300px' }}>
                    <Pie data={bookingStatusData} />
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card>
                <Card.Body>
                  <Card.Title>Revenue Trend</Card.Title>
                  <div style={{ height: '300px' }}>
                    <Bar data={revenueData} />
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <Card>
                <Card.Body>
                  <Card.Title>Vehicle Popularity</Card.Title>
                  <div style={{ height: '300px' }}>
                    <Bar data={vehiclePopularityData} />
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default Analytics;